import { define as o } from "@kickstartds/core/lib/component";
o("content.quotes-slider", () => import("./QuotesSlider.js"));